import {
  Button,
  Card,
  ListItem,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TablePagination,
  useTheme,
  TableSortLabel,
  IconButton,
  makeStyles,
  lighten,
  Paper,
  TextField,
  withStyles,
  TableFooter,
  Collapse,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import OwnerHeader from "../Components/OwnerHeader";
import { KeyboardDatePicker } from "@material-ui/pickers";
import moment from "moment";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { useHistory, useParams } from "react-router-dom";
import useSWR from "swr";
import { Autocomplete } from "@material-ui/lab";
import CustomSnakBar from "../../../Components/CustomSnakBar";
import { Instance } from "../../../Config";

import jsPDF from "jspdf";
import "jspdf-autotable";
import { CSVLink } from "react-csv";

import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import SaveAltIcon from "@material-ui/icons/SaveAlt";
import FilterListIcon from "@material-ui/icons/FilterList";
import { SHOW_SNACKBAR } from "../../../Context/globalActions.types";
import GlobalContext from "../../../Context/globalContext";

import { Skeleton } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
      backgroundColor: "#F3F3F3",
    },
  },
}))(TableRow);

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export default function SalesmanPerformance() {
  const classes = useStyles();
  const { globalContext, dispatch } = useContext(GlobalContext);
  const [fromDate, setFromDate] = useState(
    moment().subtract(30, "days").format("YYYY-MM-DD hh:mm:ss"),
  );
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD hh:mm:ss"));
  const [status, setStatus] = useState("");
  const [categoryCd, setCategoryCd] = useState("");
  const [selectedSalesman, setSelectedSalesman] = useState(null);
  const [filterSmans, setFilterSmans] = useState([]);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("totalAmount");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [rows, setRows] = useState([]);
  const [filterDept, setFilterDept] = useState([]);

  const [totalAmt, setTotalAmt] = useState(0);
  const [totalItem, setTotalItem] = useState(0);

  const [showFilters, setShowFilters] = useState(false);

  const params = useParams();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const { data: resDeptFilterData } = useSWR(
    `/reports/filters/categoryWise?mobileNo=${params.mobileNo}`,
  );

  useEffect(() => {
    if (resDeptFilterData) {
      setFilterDept(resDeptFilterData.data.result);
    }
  }, [resDeptFilterData]);

  const { data: resSmanFilterData } = useSWR(
    `/orders/filter-options/salesmen?mobileNo=${params.mobileNo}`,
  );

  useEffect(() => {
    if (resSmanFilterData) {
      setFilterSmans(resSmanFilterData.data.result || []);
    }
  }, [resSmanFilterData]);

  const handleFromDateChange = (date) => {
    setFromDate(moment(date).format("YYYY-MM-DD hh:mm:ss"));
  };

  const handleToDateChange = (date) => {
    setToDate(moment(date).format("YYYY-MM-DD hh:mm:ss"));
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const fetchData = () => {
    setIsLoading(true);
    let queryUrl = `/reports/salesmanPerformance?mobileNo=${params.mobileNo}&fromDate=${fromDate}&toDate=${toDate}`;
    if (status) queryUrl += `&status=${status}`;
    if (categoryCd) queryUrl += `&categoryCd=${categoryCd}`;
    if (selectedSalesman) queryUrl += `&salesmanCd=${selectedSalesman.SMAN_CD}`;

    Instance.get(queryUrl)
      .then((res) => {
        if (res) {
          setIsLoading(false);
          setRows(res.data.result || []);
        }
      })
      .catch(() => {
        setIsLoading(false);
        dispatch({
          type: SHOW_SNACKBAR,
          payload: { message: "Something went wrong", type: "error" },
        });
      });
  };

  const headers = [
    { label: "Salesman", key: "smanName" },
    { label: "Orders", key: "totalOrders" },
    { label: "Items Sold", key: "totalQuantity" },
    { label: "Pending", key: "statusBreakdown.Pending" },
    { label: "Dispatched", key: "statusBreakdown.Dispatched" },
    { label: "Canceled", key: "statusBreakdown.Canceled" },
    { label: "Amount", key: "totalAmount" },
  ];

  const exportPdf = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";

    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);

    const pdfHeaders = [
      [
        "Salesman",
        "Orders",
        "Items Sold",
        "Pending",
        "Dispatched",
        "Canceled",
        "Amount",
      ],
    ];

    const data = rows.map((e) => [
      e.smanName,
      e.totalOrders,
      e.totalQuantity,
      e.statusBreakdown?.Pending || 0,
      e.statusBreakdown?.Dispatched || 0,
      e.statusBreakdown?.Canceled || 0,
      e.totalAmount?.toFixed(2) || "0.00",
    ]);

    let content = {
      startY: 70,
      head: pdfHeaders,
      body: data,
    };

    let width1 = doc.internal.pageSize.getWidth();
    doc.setFontSize(14).setFont(undefined, "bold");
    doc
      .text(globalContext.company[0]?.COMP_NAME || "", width1 / 2, 20, {
        align: "center",
      })
      .setFontSize(8)
      .setFont(undefined, "bold");
    doc.text(globalContext.company[0]?.ADDRS || "", width1 / 2, 38, {
      align: "center",
    });
    doc.text(
      `From Date: ${moment(fromDate).format("DD-MM-YYYY")} To: ${moment(toDate).format("DD-MM-YYYY")}`,
      width1 / 2,
      60,
      { align: "center" },
    );
    doc.autoTable(content);
    doc.save("SalesmanPerformanceReport.pdf");
  };

  const headCells = [
    { id: "expand", label: "" },
    { id: "smanName", label: "Salesman Name" },
    { id: "totalOrders", label: "Total Orders" },
    { id: "totalQuantity", label: "Total Qty" },
    { id: "pendingStatus", label: "Pending" },
    { id: "dispatchedStatus", label: "Dispatched" },
    { id: "canceledStatus", label: "Canceled" },
    { id: "totalAmount", label: "Amount" },
  ];

  function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead className="sticky top-0">
        <TableRow className="grid grid-cols-2 py-2 md:grid-cols-9 md:mx-3 md:bg-white bg-gray-200">
          {headCells.map((headCell) => (
            <TableCell
              key={headCell.id}
              align="left"
              className={`font-bold border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-5 w-max bg-transparent ${
                headCell.id == "smanName" ? "md:col-span-2" : ""
              }`}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.id === "expand" ? (
                ""
              ) : (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  function TablePaginationActions(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    return (
      <div className={classes.root}>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
      </div>
    );
  }

  useEffect(() => {
    if (rows) {
      setTotalItem(
        rows.reduce((accumulator, object) => {
          return accumulator + (object.totalQuantity || 0);
        }, 0),
      );
      setTotalAmt(
        rows.reduce((accumulator, object) => {
          return accumulator + (object.totalAmount || 0);
        }, 0),
      );
    }
  }, [rows]);

  useEffect(() => {
    fetchData();
  }, []);

  const ExpandableRow = ({ row }) => {
    const [open, setOpen] = useState(false);

    return (
      <>
        <StyledTableRow className="grid grid-cols-2 py-1 items-center md:grid-cols-9 md:mx-3 border-t-[1px] hover:font-semibold">
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 md:col-span-2 font-medium">
            {row.smanName}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
            {row.totalOrders}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
            {row.totalQuantity}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 text-orange-600">
            {row.statusBreakdown?.Pending || 0}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 text-green-600">
            {row.statusBreakdown?.Dispatched || 0}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4 text-red-600">
            {row.statusBreakdown?.Canceled || 0}
          </StyledTableCell>
          <StyledTableCell className="border-0 pt-0 pr-[24px] pb-0 pl-[9px] text-[12px] leading-4">
            {row.totalAmount?.toFixed(2)}
          </StyledTableCell>
        </StyledTableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box margin={2}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      component="div"
                      className="text-gray-700 font-bold mb-2"
                    >
                      Top Customers by Revenue
                    </Typography>
                    <Table size="small" aria-label="purchases">
                      <TableHead>
                        <TableRow className="bg-indigo-50">
                          <TableCell className="font-semibold text-xs">
                            Customer Name
                          </TableCell>
                          <TableCell
                            align="right"
                            className="font-semibold text-xs"
                          >
                            Total Orders
                          </TableCell>
                          <TableCell
                            align="right"
                            className="font-semibold text-xs"
                          >
                            Revenue Generated (₹)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.topCustomers && row.topCustomers.length > 0 ? (
                          row.topCustomers.map((customer, idx) => (
                            <TableRow key={idx}>
                              <TableCell
                                component="th"
                                scope="row"
                                className="text-xs"
                              >
                                {customer.customerName}
                              </TableCell>
                              <TableCell align="right" className="text-xs">
                                {customer.totalOrders}
                              </TableCell>
                              <TableCell
                                align="right"
                                className="text-xs font-semibold text-indigo-700"
                              >
                                ₹{customer.totalAmount?.toFixed(2)}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              align="center"
                              className="text-xs text-gray-500"
                            >
                              No customers found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      component="div"
                      className="text-gray-700 font-bold mb-2"
                    >
                      Top Selling Items
                    </Typography>
                    <Table size="small" aria-label="purchases">
                      <TableHead>
                        <TableRow className="bg-green-50">
                          <TableCell className="font-semibold text-xs">
                            Item Name
                          </TableCell>
                          <TableCell
                            align="right"
                            className="font-semibold text-xs"
                          >
                            Quantity Sold
                          </TableCell>
                          <TableCell
                            align="right"
                            className="font-semibold text-xs"
                          >
                            Revenue (₹)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {row.topItems && row.topItems.length > 0 ? (
                          row.topItems.map((item, idx) => (
                            <TableRow key={idx}>
                              <TableCell
                                component="th"
                                scope="row"
                                className="text-xs"
                              >
                                {item.itemName}
                              </TableCell>
                              <TableCell align="right" className="text-xs">
                                {item.totalQuantity}
                              </TableCell>
                              <TableCell
                                align="right"
                                className="text-xs font-semibold text-green-700"
                              >
                                ₹{item.totalAmount?.toFixed(2)}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={3}
                              align="center"
                              className="text-xs text-gray-500"
                            >
                              No items found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </Grid>
                </Grid>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  };

  return (
    <OwnerHeader>
      <div className="md:flex items-center justify-between px-3 md:px-4 py-3">
        <div>
          <div className="text-indigo-500 font-semibold text-sm md:text-base">
            Reporting
          </div>
          <div className="text-xl md:text-2xl font-extrabold leading-7 sm:leading-10 truncate mt-1">
            Salesman Performance
          </div>
        </div>
      </div>

      <div className="py-1 min-h-screen bg-[#F1F5F9] px-2">
        <Card className="mb-4 shadow-sm">
          <ListItem className="pb-0">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <FilterListIcon className="text-indigo-500" />
                <Typography
                  variant="h6"
                  className="text-indigo-500 uppercase font-bold tracking-wider text-xs ml-2"
                >
                  Advanced Filters
                </Typography>
              </div>
              <Button size="small" onClick={() => setShowFilters(!showFilters)}>
                {showFilters ? "Hide" : "Show"}
              </Button>
            </div>
          </ListItem>
          {showFilters && (
            <div className="px-4 pb-4">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="From"
                    format="DD/MM/yyyy"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="From"
                    value={fromDate}
                    onChange={handleFromDateChange}
                    className="bg-white"
                  />
                )}
                {window.innerWidth < 600 ? (
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    label="To"
                    format="DD/MM/yyyy"
                    value={toDate}
                    onChange={handleToDateChange}
                    className="bg-white"
                  />
                ) : (
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="DD/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="To"
                    value={toDate}
                    onChange={handleToDateChange}
                    className="bg-white"
                  />
                )}
                <Autocomplete
                  id="Category"
                  autoHighlight
                  options={filterDept}
                  getOptionLabel={(option) => option.dept_name || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Category"
                      margin="normal"
                      className="bg-white mt-4"
                    />
                  )}
                  onChange={(_, value) => {
                    setCategoryCd(value ? value.DEPT_CD : "");
                  }}
                />

                <Autocomplete
                  autoHighlight
                  options={filterSmans}
                  getOptionLabel={(option) => option.SMAN_NAME || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      size="small"
                      label="Salesman"
                      margin="normal"
                      className="bg-white mt-4"
                    />
                  )}
                  onChange={(_, value) => {
                    setSelectedSalesman(value);
                  }}
                />

                <FormControl
                  variant="outlined"
                  size="small"
                  className="bg-white mt-4"
                >
                  <InputLabel>Order Status</InputLabel>
                  <Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    label="Order Status"
                  >
                    <MenuItem value="">
                      <em>All Statuses</em>
                    </MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Dispatched">Dispatched</MenuItem>
                    <MenuItem value="Canceled">Canceled</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="flex justify-end">
                <Button
                  variant="contained"
                  disableElevation
                  className="bg-[#3333cc] text-white"
                  onClick={fetchData}
                  disabled={isLoading}
                  startIcon={isLoading ? <CircularProgress size={16} style={{ color: 'white' }} /> : null}
                >
                  {isLoading ? 'Loading...' : 'Apply Filters'}
                </Button>
              </div>
            </div>
          )}
        </Card>

        <React.Fragment>
          <TableContainer
            style={{
              overflowX: "clip",
            }}
            component={Paper}
          >
            <div className="md:flex justify-between w-full my-3 px-2 pt-3">
              <Typography className="md:ml-2 text-md md:text-lg mb-2 font-medium">
                Salesman Wise Report
              </Typography>
              <div>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0"
                  startIcon={<SaveAltIcon />}
                >
                  <CSVLink
                    data={rows}
                    headers={headers}
                    filename="SalesmanPerformanceReport.csv"
                    className="text-blue-600"
                  >
                    Excel
                  </CSVLink>
                </Button>
                <Button
                  variant="outlined"
                  className="text-blue-600 border-[#3333cc] mt-2 md:mt-0 ml-2"
                  startIcon={<InsertDriveFileOutlinedIcon />}
                  onClick={() => {
                    exportPdf();
                  }}
                >
                  PDF
                </Button>
              </div>
            </div>
            <div className="max-h-screen overflow-x-hidden">
              <Table stickyHeader>
                <EnhancedTableHead
                  classes={classes}
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleRequestSort}
                  rowCount={rows ? rows.length : null}
                />
                <TableBody>
                  {isLoading && rows.length == 0 ? (
                    Array.from(new Array(5)).map((_, idx) => (
                      <StyledTableRow
                        key={idx}
                        className="grid grid-cols-2 py-1 items-center md:grid-cols-9 md:mx-3 border-t-[1px]"
                      >
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2 md:col-span-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                        <StyledTableCell className="border-0 p-2">
                          <Skeleton />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : !isLoading && rows.length == 0 ? (
                    <TableRow hover tabIndex={-1}>
                      <TableCell align="center" colSpan={9}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  ) : (
                    stableSort(rows, getComparator(order, orderBy))
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row, index) => {
                        return <ExpandableRow key={index} row={row} />;
                      })
                  )}
                </TableBody>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  component={Paper}
                  count={rows ? rows.length : null}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActions}
                  elevation={0}
                />
                {rows ? (
                  <TableFooter>
                    <TableCell>
                      <TableRow className=" text-black text-[14px]">
                        Total Item : {totalItem}
                      </TableRow>
                      <TableRow className=" text-black text-[14px]">
                        Total Amount : ₹{totalAmt?.toFixed(2)}
                      </TableRow>
                    </TableCell>
                  </TableFooter>
                ) : null}
              </Table>
            </div>
          </TableContainer>
        </React.Fragment>
      </div>
    </OwnerHeader>
  );
}
